import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { IoTrophy, IoFlame, IoBook, IoTime } from 'react-icons/io5';
import AdBanner from '../components/AdBanner';
import './Leaderboard.css';

const MEDALS = ['🥇', '🥈', '🥉'];

export default function Leaderboard() {
  const [users, setUsers] = useState([]);
  const [tab, setTab] = useState('streak');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const usersSnap = await getDocs(collection(db, 'users'));

        let librariesMap = {};
        try {
          const librariesSnap = await getDocs(collection(db, 'userLibraries'));
          librariesSnap.docs.forEach(doc => {
            librariesMap[doc.id] = doc.data();
          });
        } catch (e) {
          console.warn('userLibraries non accessible (permissions)');
        }

        const usersData = usersSnap.docs.map(doc => {
          const userData = doc.data();
          const library = librariesMap[doc.id] || {};
          return {
            id: doc.id,
            name: userData.name || 'Anonyme',
            avatarColor: userData.avatarColor || 'linear-gradient(135deg, var(--amber), var(--amber-glow))',
            avatarImage: userData.avatarImage || null,
            streak: library.streakCurrent || 0,
            bestStreak: library.streakBest || 0,
            booksCount: library.library ? library.library.length : 0,
          };
        });

        setUsers(usersData);
      } catch (e) {
        console.warn('Leaderboard: erreur chargement', e.message);
      }
    };

    fetchData();
  }, []);

  const sorted = [...users].sort((a, b) => {
    switch (tab) {
      case 'streak': return b.streak - a.streak;
      case 'bestStreak': return b.bestStreak - a.bestStreak;
      case 'books': return b.booksCount - a.booksCount;
      default: return 0;
    }
  }).filter(u => {
    switch (tab) {
      case 'streak': return u.streak > 0;
      case 'bestStreak': return u.bestStreak > 0;
      case 'books': return u.booksCount > 0;
      default: return true;
    }
  });

  const getValue = (user) => {
    switch (tab) {
      case 'streak': return user.streak + ' 🔥';
      case 'bestStreak': return user.bestStreak + ' 🏆';
      case 'books': return user.booksCount + ' 📚';
      default: return '';
    }
  };

  return (
    <div className="page leaderboard-page">
      <div className="lb-header">
        <h1 className="lb-title">Top Lecteurs</h1>
        <p className="lb-subtitle">Les lecteurs les plus actifs</p>
      </div>

      <div className="lb-tabs">
        <button className={'lb-tab ' + (tab === 'streak' ? 'lb-tab-active' : '')} onClick={() => setTab('streak')}>
          <IoFlame /> Streak
        </button>
        <button className={'lb-tab ' + (tab === 'bestStreak' ? 'lb-tab-active' : '')} onClick={() => setTab('bestStreak')}>
          <IoTrophy /> Record
        </button>
        <button className={'lb-tab ' + (tab === 'books' ? 'lb-tab-active' : '')} onClick={() => setTab('books')}>
          <IoBook /> Livres
        </button>
      </div>
            <AdBanner slot="leaderboard-top" format="horizontal" />

      <div className="lb-list">
        {sorted.length > 0 ? (
          sorted.map((user, i) => (
            <motion.div
              key={user.id}
              className={'lb-item ' + (i < 3 ? 'lb-item-top' : '')}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.04 }}
            >
              <span className="lb-rank">{i < 3 ? MEDALS[i] : '#' + (i + 1)}</span>
              <div className="lb-avatar" style={{
                background: user.avatarImage
                  ? `url(${user.avatarImage}) center/cover no-repeat`
                  : user.avatarColor
              }}>
                {!user.avatarImage && user.name.charAt(0).toUpperCase()}
              </div>
              <span className="lb-name">{user.name}</span>
              <span className="lb-value">{getValue(user)}</span>
            </motion.div>
          ))
        ) : (
          <div className="empty-state">
            <div className="empty-state-icon">🏆</div>
            <p className="empty-state-text">Aucun lecteur classé pour le moment</p>
          </div>
        )}
              <AdBanner slot="leaderboard-bottom" format="horizontal" />

      </div>
    </div>
  );
}